import { useQuery, useQueryClient } from '@tanstack/react-query'
import React, { type JSX } from 'react'

import { SettingsRow } from '../Settings'

import { deleteMfaRequired, getMfaEnabled, putEnableMfa } from 'api/clients'
import { QUERIES } from 'constants/queries'
import { Switch } from 'shared/components/Switch'

export function Mfa({ clientId }: any): JSX.Element | null {
  const queryClient = useQueryClient()
  const mfa = useQuery([QUERIES.REQUIRE_MFA, { id: clientId }], () => getMfaEnabled(clientId))
  if (mfa.isLoading) return null
  if (mfa.isError) {
    return <SettingsRow label="Require MFA for all Team Members">Could not load the MFA setting.</SettingsRow>
  }
  return (
    <SettingsRow label="Require MFA for all Team Members">
      <Switch
        defaultChecked={mfa.data.mfaEnabled}
        name="MFA settings"
        onSuccess={() => queryClient.invalidateQueries([QUERIES.REQUIRE_MFA, { id: clientId }])}
        updateEntity={async (enableMFA) => {
          if (enableMFA) {
            await putEnableMfa({ id: clientId })
          } else {
            await deleteMfaRequired({ id: clientId })
          }
        }}
      />
    </SettingsRow>
  )
}
